import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import SkipNav from '@/components/accessibility/SkipNav'
import { cn } from '@/lib/utils'
import { Toaster } from '@/components/ui/toaster'

export default function MainLayout() {
  const [isSidebarCollapsed] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  // const toggleSidebar = () => {
  //   setIsSidebarCollapsed(!isSidebarCollapsed)
  // }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <div className="flex h-screen bg-background">
      {/* Skip Navigation Links */}
      <SkipNav />
      
      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 md:hidden" 
          onClick={() => setIsMobileMenuOpen(false)}
          role="button"
          tabIndex={0}
          aria-label="Close menu"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsMobileMenuOpen(false)
            }
          }}
        />
      )}
      
      {/* Sidebar Navigation */}
      <aside 
        id="navigation"
        className={cn(
          "fixed top-0 left-0 z-50 h-full transition-transform duration-300 md:static md:translate-x-0",
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full",
          "md:block"
        )}
        aria-label="Main navigation"
        role="navigation"
      >
        <Sidebar isCollapsed={isSidebarCollapsed} />
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header 
          onMenuClick={toggleMobileMenu}
          isMenuCollapsed={isSidebarCollapsed}
        />
        
        <main 
          id="main-content"
          className="flex-1 overflow-auto p-6"
          tabIndex={-1}
          role="main"
          aria-label="Main content"
        >
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* Toast Notifications */}
      <Toaster />
    </div>
  )
}